import { Col, Form } from "react-bootstrap";

export default function DiscountInput({ onChange }) {
  return (
    <Col xs={12} sm={8} lg={6} xl={4} className="pb-2 pt-4">
      <Form.Label className="mb-0">کد تخفیف:</Form.Label>
      <Form.Control onChange={e => onChange(e.target.value)} />
    </Col>
  );
}
